import React, { createContext, PropsWithChildren } from 'react';

export const UrlContext = createContext<UrlContextData>({
  canonicalUrl: '',
});

/**
 * Provides the canonicalUrl to the rest of the component hierarchy
 *
 * @param props - Render properties
 */
export function UrlContextProvider(props: PropsWithChildren<Props>) {
  const { children, canonicalUrl } = props;
  const data = {
    canonicalUrl,
  };

  return <UrlContext.Provider value={data}>{children}</UrlContext.Provider>;
}
interface Props {
  /** The source-of-truth url for search engine crawlers to use when there is duplicate content between multiple URLs */
  canonicalUrl: string;
}
interface UrlContextData {
  /** The source-of-truth url for search engine crawlers to use when there is duplicate content between multiple URLs */
  canonicalUrl: string;
}
